import { render } from "./TIIcon.vue?vue&type=template&id=5aaebb35"
import script from "./TIIcon.vue?vue&type=script&lang=js"
export * from "./TIIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__